var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"picker",staticClass:"flex colorpicker"},[_c('span',{staticClass:"colorpicker__picker",style:({'background-color': _vm.selectedColor})}),_vm._v(" "),_c('span',{staticClass:"colorpicker__name"},[_vm._v(_vm._s(_vm.colorName))])])}
var staticRenderFns = []

export { render, staticRenderFns }